// extracted by mini-css-extract-plugin
export default {"EditUserModal":"EditUserModal_EditUserModal__KriXs"};